import { spaceCategories } from "_constants";
import isEmpty from "lodash/isEmpty";

const capacityUnit = (category) => spaceCategories[category].unit;

const withDefaults = (proposalSpace, defaults) => {
  const { area, capacity, firstRefusalRight = false, price, rentFreePeriod } = proposalSpace;

  return {
    ...proposalSpace,
    area: area ? { ...area } : { unit: defaults.sizeUnit },
    capacity: capacity ? { ...capacity } : { unit: capacityUnit(proposalSpace.category) },
    price: price ? { ...price } : { ...defaults },
    rentFreePeriod: rentFreePeriod || { period: "monthly" },
    firstRefusalRight,
  };
};

const createProposalSpace = (space, defaults) => {
  const { area, capacity, category, id, name, prices } = space;

  return {
    spaceId: id,
    category,
    name,
    area: area ? { ...area } : { unit: defaults.sizeUnit },
    capacity: capacity ? { ...capacity } : { unit: capacityUnit(space.category) },
    price: prices && prices.length ? { ...prices[prices.length - 1] } : { ...defaults },
    rentFreePeriod: { period: "monthly" },
  };
};

const getProposalSpaces = (proposal, dealSpaces, defaults) => {
  const spaces = proposal.id
    ? proposal.spaces
        .filter((s) => !isEmpty(s))
        .map((proposalSpace) => withDefaults(proposalSpace, defaults))
    : dealSpaces.map((space) => createProposalSpace(space, defaults));

  return spaces.length ? spaces : [{}];
};

export { createProposalSpace, getProposalSpaces, withDefaults };
